<template>
<div id="vy_body">
  <div id="vy_grid">
    <div id="vy_left_nav" class="p-4">
    </div>
    <div id="vy_main">
      <main>
       <br><br><br>
       <b style="color:red">本サイトは利用できません。</b>
      </main>
    </div>
    
    <div id="vy_right_nav" class="p-4">
        <!--右サイドバー-->
    </div>
  </div>
</div>
</template>

<script setup>
/* eslint-disable */
import FooterArea from '../common/FooterArea.vue'
import { GlobalData, login_check } from '../js/userdata.js';
import { useRouter, useRoute } from 'vue-router'
import { shallowRef, watch } from 'vue'
import axios from 'axios'
const url = GlobalData.$API_URL
const content = shallowRef('')
const router = useRouter();
const route = useRoute();
let param = {}

</script>
